import React, { ReactElement } from 'react';
import ActionButton from '../action-button/action-button.component';
import FlexContainer from '../flex-container/flex-container.component';
import CancelFilledIcon from '../../icons/cancel-filled-icon';
import FormatService from '../../services/format-service';
import useStylesNewItemLabelBlock from './new-item-label-block.styles';

const NewItemLabelBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const LABEL_DEFAULT: string = 'Item';
  const LABEL_EXTRA_DEFAULT: string = 'New';

  const {
    withNoExtraLabel,
    withNoCloseButton,
    label,
    labelExtra,
    className,
    onCloseClick,
  } = props;

  const { classes } = useStylesNewItemLabelBlock();

  return (
    <FlexContainer isSpread className={FormatService.formatClassNames(classes.newItemLabelBlock, className)}>
      <FlexContainer>
        {`${label || LABEL_DEFAULT}${!withNoExtraLabel ? ` (${labelExtra || LABEL_EXTRA_DEFAULT})` : ''}`}
      </FlexContainer>
      {
        !withNoCloseButton && (
          <FlexContainer>
            <ActionButton onClick={onCloseClick}>
              <CancelFilledIcon />
            </ActionButton>
          </FlexContainer>
        )
      }
    </FlexContainer>
  );
});

export default NewItemLabelBlock;
